export const heartRunnerprofileSettingsState = {
    isLoading: false,
    profileInfo: '',
    errorNumber: 0,
    errorMessage: '',
    messageLabel: '',
    statusCode:''
}